import type { PageShellProps } from '../types/layout';

const PageShell = ({
  pretitle,
  title,
  description,
  actions,
  children,
  className = '',
  bodyClassName = '',
}: PageShellProps) => {
  return (
    <div className={`app-page-shell ${className}`.trim()}>
      <div className="page-header d-print-none app-page-header">
        <div className="container-fluid px-4">
          <div className="row g-2 align-items-center">
            <div className="col">
              {pretitle && <div className="page-pretitle">{pretitle}</div>}
              <h2 className="page-title">{title}</h2>
              {description && <div className="app-page-description">{description}</div>}
            </div>
            {actions && (
              <div className="col-12 col-sm-auto ms-sm-auto d-print-none">
                <div className="btn-list app-page-actions">{actions}</div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={`page-body app-page-body ${bodyClassName}`.trim()}>
        <div className="container-fluid px-4">
          <div className="app-page-stack">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default PageShell;
